import styled, { createGlobalStyle, css } from "styled-components";

export const Container = styled.div`
  width: 100%;
  max-width: 1150px;
  padding-left: 20px;
  padding-right: 20px;
  margin-left: auto;
  margin-right: auto;
`;

export const Flex = css`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export const GlobalStyles = createGlobalStyle`
  /* Marck Script */

:root {
  --cover-bg: #020202;
  /* --main-bg: #00361c; */
  --main-bg: #031726;
  --main-color: #70dd63;
  --yellow-color: #b75002;
  --body-bg: #020202;
  --text-color: #9f9999c2;
  --hover-color: #4f8b48;
}

body {
  background-color: var(--body-bg);
  font-family: "Montserrat", sans-serif;
  min-height: 100vh;
  color: var(--text-color);
  padding-top: 10px;
  padding-bottom: 10px;
  user-select: none;
}

* {
  padding: 0;
  margin: 0;
  box-sizing: border-box;
}

*:focus {
  outline: unset;
}

a {
  text-decoration: none;
  cursor: pointer;
  color: #fff;
}

a:active,
button:active {
  transform: translateY(2px);
}

ul {
  margin: 0;
  padding: 0;
}

li {
  list-style: none;
}

img {
  display: block;
}

a,
span,
button {
  display: inline-block;
}

button {
  border: none;
  background: none;
  cursor: pointer;
}

/* Scroll styles */

*.scroll-close::-webkit-scrollbar {
  width: 0;
}

*::-webkit-scrollbar {
  width: 0px; /* Mostly for vertical scrollbars */
  border-radius: 25px;
  height: 0;
}

*::-webkit-scrollbar-thumb {
  /* Foreground */
  background: #ff7e1b;
  border-radius: 25px;
}

*::-webkit-scrollbar-track {
  /* Background */
  background: rgba(225, 220, 220, 0.845);
  border-radius: 25px;
}

`;
